<div class="d-flex align-items-center mt-3 gap-2">
  <div
    [tooltip]="tooltipMessage()"
    [tooltipEnabled]="isCheckboxDisabled() && tooltipMessage().length > 0"
    class="checkbox-wrapper"
  >
    <mat-checkbox
      [checked]="isNotApplicable()"
      [disabled]="isCheckboxDisabled()"
      (change)="onNotApplicableChange($event.checked)"
      class="not-applicable-checkbox"
      aria-label="Not Applicable"
      [attr.data-selector]="dataSelector + '-not-applicable-checkbox'"
    >
    </mat-checkbox>
  </div>
  <span [class]="'not-applicable-label ' + (isNotApplicable() ? 'not-applicable-label--checked' : 'not-applicable-label--unchecked')">Not Applicable</span>

  @if (showAddNoteButton()) {
    <button
      andButton
      color="ghost"
      size="small"
      class="add-note-btn d-flex align-items-center mt-1"
      [attr.data-selector]="dataSelector + '-add-note-btn'"
      (click)="onAddNote()"
    >
      @if (existingNote()) {
        <aiwyn-icon name="note-blank" namespace="phosphor" [height]="16" [width]="16"></aiwyn-icon>
      } @else {
        <aiwyn-icon name="plus-circle" [height]="16" [width]="16"></aiwyn-icon>
      }
      <span class="not-applicable-note-label body-400 color-gray-200">{{ noteButtonText() }}</span>
    </button>
  }
</div>
